// MeProfile.js
import { connect } from 'react-redux';
import { goBack, replace } from 'redux-first-history';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { USER_PROFILE_HOME_CATEGORIES } from '../RemoteConfigKeys.js';

import Profile from '../page/Profile.jsx';

import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
// import getUploadJobIds from '../selector/getUploadJobIds.js';
import getShouldShowEmailBindingHint from '../selector/getShouldShowEmailBindingHint.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';

import fetchFollowingTotalCount from '../action/fetchFollowingTotalCount.js';
import fetchFollowersTotalCount from '../action/fetchFollowersTotalCount.js';
import fetchMeCreator from '../action/fetchMeCreator.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import fetchFeedsTotalCount from '../action/fetchFeedsTotalCount.js';
import addModal from '../action/addModal.js';
import toggleModal from '../action/toggleModal.js';

import {
  ProfileListType,
  PROFILE_FEED_REMOTE_CONFIG_KEY_MAP,
} from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

const mapStateToProps = (state, { listType }) => {
  const meId = getMeData(state, 'id');
  const postBaseFeedName = getFeedName(
    state,
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[ProfileListType.POST],
    '{USER_ID}',
    meId
  );
  const { feedNameWithQuery: postFeedNameWithQuery } =
    getSelectedQueryOptionObject(state, postBaseFeedName);
  const outboxFeedRemoteConfigKeyName =
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[listType];
  const outboxFeedName = getFeedName(
    state,
    outboxFeedRemoteConfigKeyName,
    '{USER_ID}',
    meId
  );
  const { feedNameWithQuery } = getSelectedQueryOptionObject(
    state,
    outboxFeedName,
    getSelectedFeedQueryOptions(
      state,
      outboxFeedRemoteConfigKeyName,
      undefined
    ),
    getRemoteConfigData(
      state,
      `${outboxFeedRemoteConfigKeyName}_${QueryPrefix[QueryType.SORT]}`
    )?.[0]
  );
  const listSelectPath = [
    'home',
    getReturnType({ feedName: feedNameWithQuery }),
    feedNameWithQuery,
  ];
  return {
    feedNameWithQuery,
    postFeedNameWithQuery,
    listType,
    meId,
    username: getMeData(state, 'username'),
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(
      state,
      meId,
      listType
    ),
    isFirstPageFetched: getNetworkingData(
      state,
      [...listSelectPath, 1],
      'isFetched'
    ),
    isFirstPageFetching: getNetworkingData(
      state,
      [...listSelectPath, 1],
      'isFetching'
    ),
    shouldShowEmailBindingHint: getShouldShowEmailBindingHint(state),
    categories: getRemoteConfigData(
      state,
      USER_PROFILE_HOME_CATEGORIES,
      undefined,
      {
        USER_ID: meId,
      }
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    replace: ({ pathname }) => dispatch(replace(pathname)),
    fetchFollowingTotalCount: () => dispatch(fetchFollowingTotalCount()),
    fetchFollowersTotalCount: () => dispatch(fetchFollowersTotalCount()),
    fetchMeCreator: () => dispatch(fetchMeCreator()),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    fetchFeedsTotalCount: payload => dispatch(fetchFeedsTotalCount(payload)),
    addModal: ({ id }) =>
      dispatch(addModal({ id, transitionStatus: 'opening' })),
    toggleModal: ({ modalId, payload, isOpen }) =>
      dispatch(toggleModal({ modalId, payload, isOpen })),
    updateProfileFeedUnixTimestamp: ({ unixTimestamp }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['profileFeed'],
          data: {
            unixTimestamp,
          },
        },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
